module.exports = new __parcel__URL__("testimonial-dominic-hamdy.7a029c2b.webp").toString();